import React, { useEffect, useState, useRef } from 'react'
import Head from 'next/head'
import { WeddingsWrapper } from '../components/weddings/styles'
import { services } from '../components/weddings/data'
import Hero from '../components/Hero'
import HeroImage from '../../public/weddings/new_GS_wedding_hero.jpg'
import WhyGlamsquad from '../components/WhyGlamsquad'
import { useMarketContext } from '../components/MarketContext'
import MarketServiceSelector from '../components/MarketServiceSelector/MarketServiceSelector'
import ServiceCardList from '../components/ServiceCardList'
import AsSeenIn from '../components/weddings/AsSeenIn'
import ImageScroll from '../components/ImageScroll'
import FAQ from '../faq'
import Request from '../components/weddings/Request'
import HeaderContent from '../components/weddings/HeaderContent'
import gridOne from '../../public/weddings/wedding-grid-1.jpg'
import gridTwo from '../../public/weddings/wedding-grid-2.jpg'
import gridThree from '../../public/weddings/wedding-grid-3.jpg'
import gridFour from '../../public/weddings/wedding-grid-4.jpg'
import gridFive from '../../public/weddings/wedding-grid-5.jpg'
import gridSix from '../../public/weddings/wedding-grid-6.jpg'
import gridSeven from '../../public/weddings/wedding-grid-7.jpg'
import gridEight from '../../public/weddings/wedding-grid-8.jpg'
import gridNine from '../../public/weddings/wedding-grid-9.jpg'
import gridTen from '../../public/weddings/wedding-grid-10.jpg'
import gridEleven from '../../public/weddings/wedding-grid-11.jpg'
import gridTwelve from '../../public/weddings/wedding-grid-12.jpg'

const images = [
  gridOne,
  gridTwo,
  gridThree,
  gridFour,
  gridFive,
  gridSix,
  gridSeven,
  gridEight,
  gridNine,
  gridTen,
  gridEleven,
  gridTwelve,
]

const faqUrl = 'https://help.glamsquad.com/en-US/articles/weddings-47019'
const faqData = [
  {
    id: 0,
    title: 'How do I book a bridal or wedding service?',
    body: 'Book your own trial through the Glamsquad app or website and our weddings concierge will reach out to you to confirm the details for your wedding trial and start planning your wedding day beauty.',
  },
  {
    id: 1,
    title: 'Why should I book a bridal trial?',
    body: 'Trials differ from standard bookings as they include an in-depth consultation with your bridal-certified beauty professional to discuss all aspects of your wedding day aesthetic and desired bridal beauty look. Your beauty professional will create your desired hairstyle and/or makeup look via a step-by-step process so you can share feedback along the way to ensure you look and feel like the best version of yourself on your most special day.',
  },
  {
    id: 2,
    title: 'Who are Glamsquad bridal-certified beauty professionals?',
    body: 'Our talented bridal-certified hairstylists and makeup artists are hand selected and highly vetted. They have an average of 7 years experience in the bridal beauty space and have gone through additional Glamsquad education as well as bridal-specific trend courses to guarantee the highest quality with every Glamsquad wedding experience.',
  },
]

const Weddings = () => {
  const { markets, selectedMarket, setSelectedMarket } = useMarketContext()

  // service type bar selected state
  const [selectedTab, setSelectedTab] = useState('')

  // observer logic for detecting section scroll into view
  const observer = useRef(null)
  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setSelectedTab(entry.target.id)
      }
    })
  }

  useEffect(() => {
    observer.current = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: '-50%',
    })

    const container = document.querySelector('.content-wrapper')
    if (container) {
      Array.from(container.children).forEach((child) =>
        observer.current.observe(child),
      )
    }

    return () => {
      observer.current.disconnect()
    }
  }, [])

  return (
    <>
      <Head>
        <title>Weddings | Glamsquad</title>
      </Head>
      <WeddingsWrapper>
        <Hero
          image={HeroImage}
          className="hero-component"
          content={<HeaderContent />}
        />
        <WhyGlamsquad />
        <MarketServiceSelector
          markets={markets}
          selectedMarket={selectedMarket}
          setSelectedMarket={setSelectedMarket}
          services={services}
          selectedTab={selectedTab}
          marketPrompt="Wedding services in: "
        />
        <ServiceCardList services={services} selectedMarket={selectedMarket} />
        <AsSeenIn />
        <ImageScroll images={images} />
        <FAQ data={faqData} url={faqUrl} />
        <Request />
      </WeddingsWrapper>
    </>
  )
}

export default Weddings
